import { Fragment } from "react";
import { Link } from "react-router-dom";
import { ChevronRight, LucideIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import HeroBulge from "../HeroBulge/HeroBulge";
import "./TitleBand.css";

type Crumb = { label: string; to: string };

type TitleBandProps = {
  title: React.ReactNode;
  icon?: LucideIcon;
  crumbs?: Crumb[];
  /** Título curto: no mobile fica numa linha só, com a fonte reduzida até caber. */
  singleLine?: boolean;
};

// Topo das páginas internas (soluções, cases): caminho opcional e o título. A grade animada do hero da Home
// (HeroBulge), com a bolha do mesmo tamanho, fica só numa faixa da altura do título (a máscara no CSS apaga as bordas).
// O selo do ícone e as formas reagem à bolha (data-bulge="shape").
export default function TitleBand({ title, icon: Icon, crumbs = [], singleLine = false }: TitleBandProps) {
  const { t } = useTranslation();

  return (
    <>
      {crumbs.length > 0 && (
        <nav className="cz-title-crumbs" aria-label={t("solutions_page.breadcrumb", "Você está em")}>
          {crumbs.map((crumb, i) => (
            <Fragment key={crumb.to}>
              {i > 0 && <ChevronRight size={14} aria-hidden="true" />}
              <Link to={crumb.to}>{crumb.label}</Link>
            </Fragment>
          ))}
        </nav>
      )}

      <section className={`cz-title-band${singleLine ? " cz-title-band--single" : ""}`}>
        <HeroBulge tone="light" size={0.45} />
        <span className="cz-shape cz-shape--drop cz-title-band__drop" data-bulge="shape" aria-hidden="true" />
        <span className="cz-shape cz-shape--orb cz-title-band__orb" data-bulge="shape" aria-hidden="true" />
        <div className="cz-title-band__inner">
          {Icon && (
            <span className="cz-title-band__badge" data-bulge="shape" aria-hidden="true">
              <Icon size={26} strokeWidth={1.6} />
            </span>
          )}
          <h1 className="cz-title-band__title">{title}</h1>
        </div>
      </section>
    </>
  );
}
